import ValuesBar from "./ValuesBar";

function ComparisonBars({ stat, onStatClicked }) {
  // Percent stats also show the raw fraction they're computed from, e.g.
  // "(10/20) 50%", when the caller provided it (num/den).
  const valueString = (val, num, den) => {
    if (!stat.isPercent) return val;
    const fraction = den !== undefined ? `(${num ?? 0}/${den}) ` : "";
    return `${fraction}${val}%`;
  };

  return (
    <>
      <div className="rounded-none mt-4 px-3">
        <div className="flex justify-between mb-1">
          <p
            className="text-xs cursor-pointer"
            onClick={() => onStatClicked(stat.events1, stat, 1)}
          >
            {valueString(stat.value1, stat.num1, stat.den1)}
          </p>
          <p className="text-xs font-bold">{stat.label}</p>
          <p
            className="text-xs cursor-pointer"
            onClick={() => onStatClicked(stat.events2, stat, 2)}
          >
            {valueString(stat.value2, stat.num2, stat.den2)}
          </p>
        </div>
        <div className="flex mb-6">
          <ValuesBar stat={stat} />
        </div>
      </div>
    </>
  );
}

export default ComparisonBars;
